__turbopack_context__.v({
  "cluster": "LeafletMap-module-scss-module__6ixcsW__cluster",
  "custom-icon": "LeafletMap-module-scss-module__6ixcsW__custom-icon",
  "leaflet-cluster-anim": "LeafletMap-module-scss-module__6ixcsW__leaflet-cluster-anim",
  "leaflet-cluster-spider-leg": "LeafletMap-module-scss-module__6ixcsW__leaflet-cluster-spider-leg",
  "leaflet-marker-icon": "LeafletMap-module-scss-module__6ixcsW__leaflet-marker-icon",
  "leaflet-marker-shadow": "LeafletMap-module-scss-module__6ixcsW__leaflet-marker-shadow",
  "leaflet-oldie": "LeafletMap-module-scss-module__6ixcsW__leaflet-oldie",
  "leafletMapContainer": "LeafletMap-module-scss-module__6ixcsW__leafletMapContainer",
  "leafletMapContainerGrayscale": "LeafletMap-module-scss-module__6ixcsW__leafletMapContainerGrayscale",
  "marker-cluster": "LeafletMap-module-scss-module__6ixcsW__marker-cluster",
  "marker-cluster-large": "LeafletMap-module-scss-module__6ixcsW__marker-cluster-large",
  "marker-cluster-medium": "LeafletMap-module-scss-module__6ixcsW__marker-cluster-medium",
  "marker-cluster-small": "LeafletMap-module-scss-module__6ixcsW__marker-cluster-small",
  "pin": "LeafletMap-module-scss-module__6ixcsW__pin",
});
